'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { GameMechanics } from './schema'

const GameMechanicsContext = createContext<GameMechanics | null>(null)

export function GameMechanicsProvider({
  profile,
  children
}: {
  profile: GameMechanics
  children: ReactNode
}) {
  return <GameMechanicsContext.Provider value={profile}>{children}</GameMechanicsContext.Provider>
}

// Throws at the boundary instead of silently returning stale defaults.
// If this ever fires in production the fix is either "mount the provider"
// or "fix the DB row" — not "add a fallback."
export function useGameMechanics(): GameMechanics {
  const value = useContext(GameMechanicsContext)
  if (!value) {
    throw new Error(
      'useGameMechanics must be used within a <GameMechanicsProvider>. ' +
        'Ensure the server-loaded profile is passed into the provider in the root layout.'
    )
  }
  return value
}
